module.exports = __webpack_public_path__ + "img/home-clothing3.58e6bd4f.png";